import React from 'react';
import Dropzone from 'react-dropzone';
import { styled } from 'styled-components';
import File from './File/index.js';
import X from './Icons/X.js';
const FileInput = (props) => {
    const onDrop = async (acceptedFiles) => {
        startUpload(acceptedFiles[0]);
    };
    const startUpload = async (uploadFile) => {
        const content = await promiseFileReader(uploadFile);
        const { file } = await props.fileUpload({
            content: content.split('base64,')[1],
            name: uploadFile.name,
            contentType: uploadFile.type,
        });
        props.onChange(file);
    };
    const promiseFileReader = async (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = async (event) => {
                resolve(event.target.result);
            };
            reader.onerror = reject;
            reader.readAsDataURL(file);
        });
    };
    return (React.createElement(FileInputStyled, null, React.createElement(Dropzone, { multiple: false, acceptStyle: {
            background: 'lightgreen',
        }, rejectStyle: {
            background: 'red',
        }, disableClick: true, onDrop: onDrop },
        props.children,
        props.file && React.createElement(File, { file: props.file }),
        props.file && (React.createElement(X, { onClick: () => {
                props.onChange(null);
            } })))));
};
export default FileInput;
const FileInputStyled = styled.div `
  background-color: lightgrey;
  & > div {
    min-height: 40px;
  }
`;
//# sourceMappingURL=FileInput.js.map